module.exports = __webpack_public_path__ + "img/3-1.a70b7b60.png";